import { Component, OnInit, Input, Output } from '@angular/core';

import { FormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';


import * as _moment from 'moment';
import { defaultFormat as _rollupMoment, Moment } from 'moment';

import { NgZone } from "@angular/core";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { TtsService } from 'src/app/services/tts/tts.service';

import { MatSnackBar } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ViewMessageTtsComponent } from '../popups/view-message-tts/view-message-tts.component';


am4core.useTheme(am4themes_animated);



export const MY_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'app-tts',
    templateUrl: './tts.component.html',
    styleUrls: ['./tts.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
})
export class TtsComponent implements OnInit {

    public atualPage = 'tts';

    public tts = [];
    public filteredTts = [];
    public loading = true;
    public searchFilter = "";

    date = new FormControl(_moment());
    public labelDateSelected;
    public months = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro"
    ];

    // Filtros
    public phone_type = "0";
    public status = "todos";

    constructor(
        private zone: NgZone,
        private ttsService : TtsService,
        private snackBar: MatSnackBar,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.labelDateSelected = this.months[this.date.value.month()] + "/" + this.date.value.year();
        this.getTts();
    }

    ngAfterViewInit() {
        
    }

    chosenYearHandler(normalizedYear: Moment) {
        const ctrlValue = this.date.value;
        ctrlValue.year(normalizedYear.year());
        this.date.setValue(ctrlValue);
    }

    chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.date.value;
        ctrlValue.month(normalizedMonth.month());
        this.date.setValue(ctrlValue);
        this.labelDateSelected = this.months[normalizedMonth.month()] + "/" + normalizedMonth.year();
        this.getTts();
        datepicker.close();
    }

    getTts() {
        this.loading = true;
        let month = this.date.value.month()+1;
        let year = this.date.value.year();
        let phone_type = JSON.parse(JSON.stringify(this.phone_type));
        let status = JSON.parse(JSON.stringify(this.status));

        this.ttsService.list(month, year, phone_type, status).subscribe((res) => {
            this.tts = res.tts;
            this.tts.forEach((item) => {
                item.duration = new Date(item.duration * 1000).toISOString().substr(11, 8);
            })
            this._filter();
            this.loading = false;
        })
    }

    _filter() {
        let search = JSON.parse(JSON.stringify(this.searchFilter)).toUpperCase();
        if (search) {
            this.filteredTts = this.tts.filter((item) => {
                for (var key in item) {
                    if (String(item[key]).toUpperCase().includes(search)) {
                        return true;
                    }
                }
            })
        } else {
            this.filteredTts = JSON.parse(JSON.stringify(this.tts));
        }
    }

    getNow() {
        return new Date();
    }

    viewMessage(message:string) {
        const dialogRef = this.dialog.open(ViewMessageTtsComponent, {
            width: '400px',
            data: {
                message: message
            }
        });
    }
}
